var swiper = new Swiper('.swiper-container', {
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
    autoplay: {
    delay: 2500, 
    disableOnInteraction: false, 
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  slidesPerView: 1, 
});



var swiper2 = new Swiper('.swiper-container-2', {
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      }, 
  autoplay: {
    delay: 2500, 
    disableOnInteraction: false, 
  },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      slidesPerView: 1, 
      breakpoints: {
        768: {
          slidesPerView: 1, 
        },
      },
    });




 function startCountdown(duration) {
            let timer = duration, hours, minutes, seconds;
            const hoursDigits = document.querySelectorAll('#hours .time-digit');
            const minutesDigits = document.querySelectorAll('#minutes .time-digit');
            const secondsDigits = document.querySelectorAll('#seconds .time-digit');

            const countdownInterval = setInterval(() => {
                hours = Math.floor(timer / 3600);
                minutes = Math.floor((timer % 3600) / 60);
                seconds = timer % 60;

                const hoursStr = hours < 10 ? "0" + hours : String(hours);
                const minutesStr = minutes < 10 ? "0" + minutes : String(minutes);
                const secondsStr = seconds < 10 ? "0" + seconds : String(seconds);

                hoursDigits[0].textContent = hoursStr.charAt(0);
                hoursDigits[1].textContent = hoursStr.charAt(1);
                minutesDigits[0].textContent = minutesStr.charAt(0);
                minutesDigits[1].textContent = minutesStr.charAt(1);
                secondsDigits[0].textContent = secondsStr.charAt(0);
                secondsDigits[1].textContent = secondsStr.charAt(1);

                if (--timer < 0) {
                    clearInterval(countdownInterval);
                }
            }, 1000);
        }

        window.onload = function () {
            // El temporizador se inicia en 1 hora (3600 segundos)
            const oneHour = 3600;
            startCountdown(oneHour);
        };